<template>
  <div class="row">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Base'
};
</script>

<style lang="scss">
  @import './style/base.scss';
</style>



// WEBPACK FOOTER //
// src/views/Base.vue